import { isEmpty } from "./datatype_helpers";

const validateTrainee = (trainee) => {
    const { first_name, last_name, email, role_list } = trainee;
    const errors = {
      first_name: isEmpty(first_name) && "Must have a first name",
      last_name: isEmpty(last_name) && "Must have a last name",
      email: isEmpty(email) && "Must have an email",
      role_list: isEmpty(role_list) && "Must have a role",
    };
    return errors;
  }
  
  export {
    validateTrainee
  }


// WEBPACK FOOTER //
// ./src/helpers/trainee_helpers.js